// extracted by mini-css-extract-plugin
module.exports = {"block":"TopHeader_block__CY_D1","mobileSort":"TopHeader_mobileSort__cE_wp"};